module.exports = __webpack_public_path__ + "img/img113.2bbe0965.svg";